import { Link } from 'react-router-dom';

const SERVICES = [
  { label: 'Chimney Cleaning Jacksonville FL', href: '/services/chimney-cleaning' },
  { label: 'Air Duct Cleaning Jacksonville FL', href: '/services/air-duct-cleaning' },
  { label: 'Dryer Vent Cleaning Jacksonville FL', href: '/services/dryer-vent-cleaning' },
];

const QUICK_LINKS = [
  { label: 'About Us', href: '/about' },
  { label: 'Our Process', href: '/process' },
  { label: 'Gallery', href: '/gallery' },
  { label: 'Service Areas', href: '/service-areas' },
  { label: 'Reviews', href: '/reviews' },
  { label: 'Blog', href: '/blog' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contact', href: '/contact' },
];

const SERVICE_AREAS = [
  'Jacksonville', 'Ponte Vedra', 'Orange Park', 'Mandarin',
  'Jacksonville Beach', 'Neptune Beach', 'Atlantic Beach', 'Fleming Island',
  'Nocatee', 'San Marco', 'Riverside', 'St. Augustine',
];

export default function Footer() {
  return (
    <footer className="bg-[#141210]">
      {/* CTA Banner */}
      <div className="bg-brand-amber">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white font-bold text-lg">
            Ready to schedule your service in Jacksonville?
          </p>
          <div className="flex items-center gap-3">
            <a
              href="tel:+19045550191"
              className="bg-white text-brand-amber font-bold px-6 py-2.5 rounded-xl text-sm transition-all hover:bg-amber-50 cursor-pointer whitespace-nowrap"
            >
              Call (904) 555-0191
            </a>
            <Link
              to="/contact"
              className="bg-brand-dark text-white font-semibold px-6 py-2.5 rounded-xl text-sm transition-all hover:bg-brand-light cursor-pointer whitespace-nowrap"
            >
              Get a Free Quote
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex mb-5 cursor-pointer" aria-label="BBM Services - Home">
              <div className="bg-white rounded-xl overflow-hidden p-1.5">
                <img
                  src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/c93e9219dae2cf80448e9bdc5a16dd68.jpeg"
                  alt="BBM Services Logo — Jacksonville FL"
                  className="h-16 w-auto object-contain"
                />
              </div>
            </Link>
            <p className="text-white/45 text-sm leading-relaxed mb-6">
              Jacksonville's trusted specialists in <strong className="text-white/70">chimney cleaning</strong>, <strong className="text-white/70">air duct cleaning</strong>, and <strong className="text-white/70">dryer vent cleaning</strong>. Certified, insured, and dedicated to your home's safety since 2010.
            </p>

            <div className="space-y-3">
              <div className="flex items-center gap-2.5 text-sm text-white/50">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-brand-amber" />
                </div>
                Jacksonville, Florida 32099
              </div>
              <a href="tel:+19045550191" className="flex items-center gap-2.5 text-sm text-white/50 hover:text-brand-amber transition-colors cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-brand-amber" />
                </div>
                (904) 555-0191
              </a>
              <a href="mailto:info@bbmservices.com" className="flex items-center gap-2.5 text-sm text-white/50 hover:text-brand-amber transition-colors cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-brand-amber" />
                </div>
                info@bbmservices.com
              </a>
            </div>

            {/* Certifications */}
            <div className="mt-6 flex gap-3">
              <div className="bg-white/8 border border-white/10 rounded-lg px-3 py-2 text-center">
                <div className="text-brand-amber text-xs font-bold">CSIA</div>
                <div className="text-white/35 text-xs">Certified</div>
              </div>
              <div className="bg-white/8 border border-white/10 rounded-lg px-3 py-2 text-center">
                <div className="text-brand-amber text-xs font-bold">NADCA</div>
                <div className="text-white/35 text-xs">Member</div>
              </div>
              <div className="bg-white/8 border border-white/10 rounded-lg px-3 py-2 text-center">
                <div className="text-brand-amber text-xs font-bold">FL LIC</div>
                <div className="text-white/35 text-xs">Licensed</div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-5 uppercase tracking-widest">Our Services</h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.href}>
                  <Link
                    to={s.href}
                    className="flex items-center gap-2 text-sm text-white/45 hover:text-brand-amber transition-colors cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-s-line text-brand-amber" />
                    </div>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest">Hours</h4>
              <div className="space-y-1.5 text-sm text-white/45">
                <div className="flex justify-between">
                  <span>Mon – Fri</span>
                  <span className="text-white/60">8:00am – 6:00pm</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span className="text-white/60">9:00am – 3:00pm</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span className="text-white/35">Closed</span>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-5 uppercase tracking-widest">Quick Links</h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="flex items-center gap-2 text-sm text-white/45 hover:text-brand-amber transition-colors cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-s-line text-brand-amber" />
                    </div>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-5 uppercase tracking-widest">Service Areas</h4>
            <div className="grid grid-cols-2 gap-y-2.5 gap-x-2 mb-6">
              {SERVICE_AREAS.map((area) => (
                <Link
                  key={area}
                  to="/service-areas"
                  className="text-xs text-white/40 hover:text-brand-amber transition-colors cursor-pointer"
                >
                  {area}
                </Link>
              ))}
            </div>
            <div className="p-4 bg-brand-amber/12 border border-brand-amber/20 rounded-xl">
              <div className="flex items-center gap-2 mb-1.5">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-2-fill text-brand-amber text-sm" />
                </div>
                <span className="text-white/70 text-xs font-semibold">Duval · St. Johns · Clay · Nassau</span>
              </div>
              <p className="text-white/35 text-xs">Serving greater Jacksonville and all surrounding counties.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/30">
          <span>&copy; {new Date().getFullYear()} BBM Services LLC. All rights reserved. Jacksonville, FL.</span>
          <div className="flex flex-wrap gap-3 text-white/25">
            <span>Chimney Cleaning Jacksonville FL</span>
            <span>·</span>
            <span>Air Duct Cleaning Jacksonville</span>
            <span>·</span>
            <span>Dryer Vent Cleaning Jacksonville</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
